import { IconWrapper } from '../runtime';
export default IconWrapper('fish', true, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48",
      "fill": "none"
    }
  }, [h("g", {
    "attrs": {
      "clip-path": 'url(#' + props.id + 'e9317391' + ')'
    }
  }, [h("path", {
    "attrs": {
      "d": "M15.3808 32.844C9.72351 31.4294 0.531437 34.9652 9.72365 38.5006C13.2595 47.6933 16.7947 38.5006 15.3808 32.844Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M22.4823 10.2475C17.5789 10.2344 11.2504 11.7843 10.4533 13.9754C9.87553 15.5637 12.878 17.6767 16.7036 18.7932",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M37.9776 25.7423C37.9907 30.6457 36.4407 36.9742 34.2497 37.7713C32.6614 38.3491 30.5484 35.3466 29.4319 31.521",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M37.9993 25.7646C44.6625 19.6999 40.1249 8.0912 40.1249 8.0912C40.1249 8.0912 28.1079 4.55954 22.4511 10.2164C16.7942 15.8732 15.38 32.8438 15.38 32.8438C15.38 32.8438 31.3362 31.8294 37.9993 25.7646Z",
      "fill": props.colors[1],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M38.0075 25.7731C38.0075 25.7731 31.29 24.7125 27.4009 20.8234C23.5118 16.9343 22.4512 10.2168 22.4512 10.2168",
      "stroke": props.colors[2],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("circle", {
    "attrs": {
      "cx": "33.7656",
      "cy": "14.4593",
      "r": "2",
      "transform": "rotate(45 33.7656 14.4593)",
      "fill": props.colors[2]
    }
  }), h("path", {
    "attrs": {
      "d": "M40.9998 20.9447C40.4591 22.7043 39.5215 24.3792 37.9993 25.7647C36.3518 27.2642 34.1363 28.4549 31.7344 29.3979",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  }), h("path", {
    "attrs": {
      "d": "M27.0002 7.65642C25.3026 8.14453 23.7176 8.9504 22.4513 10.2167C21.2665 11.4015 20.2678 13.0826 19.4293 15",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })]), h("defs", [h("clipPath", {
    "attrs": {
      "id": props.id + 'e9317391'
    }
  }, [h("rect", {
    "attrs": {
      "width": "48",
      "height": "48",
      "fill": props.colors[2]
    }
  })])])]);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@icon-park/vue/es/icons/Fish.js
// module id = null
// module chunks = 